import Flex from '@talkdesk/cobalt-react-flex'
import Box from '@talkdesk/cobalt-react-box'
import Image from '@talkdesk/cobalt-react-image'
import Button from '@talkdesk/cobalt-react-button'
import { HEADER_ACTION, LOGO_ALTERNATE_TEXT } from '../../constants/ui.labels'
import { ROOT } from '../../constants/links'
import { TALKDESK_LOGO } from '../../constants/images'
import { constantBuilder } from '../../utils/index'

const TalkdeskNavbar = ({ brandingSettings: { branding }, redirect }) => {
  return (
    <Box width="100%" style={{ boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)' }}>
      <Flex alignY="center" paddingX={4} paddingY={2}>
        {branding.assets && (
          <Flex style={{ marginRight: 'auto' }}>
            <a href={ROOT}>
              <Image
                src={TALKDESK_LOGO(branding.assets)}
                alt={constantBuilder(LOGO_ALTERNATE_TEXT, {
                  name: branding.name
                })}
                width={100}
                height={20}
              />
            </a>
          </Flex>
        )}
        {redirect && (
          <Flex style={{ marginLeft: 'auto' }}>
            <Button onClick={() => redirect()} type="secondary" size="small">
              {HEADER_ACTION}
            </Button>
          </Flex>
        )}
      </Flex>
    </Box>
  )
}

export default TalkdeskNavbar
